import { isDefined } from "@clipboard-health/util-ts";
import { useGetAddressByGeoCode } from "@src/appV2/lib/GoogleMaps/api/useGetAddressByGeoCode";
import { convertToGoogleMapsLocation } from "@src/appV2/Location/utils";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";

export function useGetLocationLabel(): string | undefined {
  const geoLocation = useWorkerGeoLocation();
  const googleMapsLocation = isDefined(geoLocation)
    ? convertToGoogleMapsLocation(geoLocation)
    : undefined;
  const { data: address } = useGetAddressByGeoCode(googleMapsLocation);

  if (!isDefined(address?.city) || !isDefined(address?.stateCode)) {
    return undefined;
  }

  return `${address.city}, ${address.stateCode}`;
}
